import React from 'react';
interface SectionProps {
  id?: string;
  eyebrow?: string;
  title?: React.ReactNode;
  intro?: React.ReactNode;
  tone?: 'white' | 'tint' | 'rose' | 'deep';
  width?: 'content' | 'narrow';
  children: React.ReactNode;
}
const toneClasses: Record<NonNullable<SectionProps['tone']>, string> = {
  white: 'bg-white text-neutral-800',
  tint: 'bg-stone-50 text-neutral-800',
  rose: 'bg-pink-100 text-neutral-800',
  deep: 'bg-pink-950 text-white'
};
export function Section({
  id,
  eyebrow,
  title,
  intro,
  tone = 'white',
  width = 'content',
  children
}: SectionProps) {
  const hasHeader = Boolean(eyebrow || title || intro);
  const isDeep = tone === 'deep';
  return <section id={id} className={`w-full py-16 md:py-24 ${toneClasses[tone]}`} data-id="element-131" data-mp="7oyfaase0vm9">
      <div className={`mx-auto w-full px-5 md:px-8 ${width === 'narrow' ? 'max-w-3xl' : 'max-w-5xl'}`} data-id="element-132" data-mp="7mveqwtlzk3a">
        {hasHeader && <header className="mx-auto max-w-3xl text-center" data-id="element-133" data-mp="1060zzjye1xhk">
            {eyebrow && <p className={`mb-4 text-xs font-extrabold uppercase tracking-widest ${isDeep ? 'text-pink-300' : 'text-pink-700'}`} data-id="element-134" data-mp="2zln0zj2q4xew">
                {eyebrow}
              </p>}
            {title && <h2 className={`text-3xl font-extrabold leading-tight tracking-tight md:text-5xl ${isDeep ? 'text-white' : 'text-neutral-800'}`} data-id="element-135" data-mp="33lnjbesy1sr8">
                {title}
              </h2>}
            {intro && <p className={`mx-auto mt-5 max-w-2xl text-lg md:text-xl ${isDeep ? 'text-pink-100' : 'text-neutral-500'}`} data-id="element-136" data-mp="3rc9pf0je12yl">
                {intro}
              </p>}
          </header>}
        <div className={hasHeader ? 'mt-12 md:mt-16' : ''} data-id="element-137" data-mp="1wzjt6c5jrho1">{children}</div>
      </div>
    </section>;
}